import {
  AfterViewInit, Component, OnDestroy, ViewChild, ViewContainerRef,
} from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import dayjs from 'dayjs';
import { DashboardComponentPair, DEFAULT_DASHBOARD_CONFIG } from '@models/dashboard';
import { DashboardService } from '@services/dashboard.service';
import { JobDashboardComponent } from './job-dashboard/job-dashboard.component';
import { WorkerDashboardComponent } from './worker-dashboard/worker-dashboard.component';
import { WorkerDashboardFormComponent } from './worker-dashboard/worker-dashboard-form.component';
import { JobDashboardFormComponent } from './job-dashboard/job-dashboard-form.component';
import { WorkflowDashboardComponent } from './workflow-dashboard/workflow-dashboard.component';
import { SmartwatchDashboardComponent } from './smartwatch-dashboard/smartwatch-dashboard.component';
import { SmartwatchDashboardFormComponent } from './smartwatch-dashboard/smartwatch-dashboard-form.component';

_('dashboard.title');

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements AfterViewInit, OnDestroy {
  @ViewChild('dashboardContainer', { read: ViewContainerRef }) containerRef!: ViewContainerRef;

  date = dayjs();

  private interval?: ReturnType<typeof setInterval> = undefined;

  protected isLoading = true;

  static componentRegistry: { [key: string]: DashboardComponentPair } = {
    JobDashboardComponent: {
      view: JobDashboardComponent,
      form: JobDashboardFormComponent,
    },
    SmartwatchDashboardComponent: {
      view: SmartwatchDashboardComponent,
      form: SmartwatchDashboardFormComponent,
    },
    WorkerDashboardComponent: {
      view: WorkerDashboardComponent,
      form: WorkerDashboardFormComponent,
    },
    WorkflowDashboardComponent: {
      view: WorkflowDashboardComponent,
      form: WorkerDashboardFormComponent,
    },
  };

  constructor(private dashboardService: DashboardService) {}

  ngAfterViewInit() {
    this.initDashboard();
    this.interval = setInterval(() => {
      this.date = dayjs();
    }, 10000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  private initDashboard() {
    this.dashboardService.getDashboard().subscribe((dashboard) => {
      const configuration = dashboard?.configuration || DEFAULT_DASHBOARD_CONFIG;

      configuration.items.forEach((itemConfig) => {
        const componentName = itemConfig.component;
        const componentClass = DashboardComponent.componentRegistry[componentName].view;
        if (componentClass) {
          const component = this.containerRef.createComponent(componentClass);
          component.location.nativeElement.classList.add(itemConfig.size);
          component.location.nativeElement.classList.add('mb-4');
          component.instance.setConfiguration(itemConfig.configuration);
          component.instance.loadData();
        }
      });
      this.isLoading = false;
    });
  }
}
